import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch, type PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MiniatureLineChart',
  props: {
  chartData: { type: Array as PropType<Array<string>>, required: true },
  chartStyle: { type: Object, required: false },
  fillColor: { type: String, required: false },
  lineColor: { type: String, required: true },
},
  setup(__props) {

const props = __props;

const buildChart = computed(() => Boolean(props.chartData.length));
const getDatasetData = () => {
  const cd: Array<string | undefined> = props.chartData;

  if (cd.length === 1) {
    cd.push(cd[0]);
  }

  return cd;
};

const getAnimation = (datasetLength: number, totalDuration = 2_000) => {
  const delayBetweenPoints = totalDuration / datasetLength;
  const previousY = (ctx) => (ctx.index === 0 ? ctx.chart.scales.y.getPixelForValue(100) : ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1].getProps(['y'], true).y);

  return {
    x: {
      type: 'number',
      easing: 'linear',
      duration: delayBetweenPoints,
      from: NaN, // the point is initially skipped
      delay(ctx) {
        if (ctx.type !== 'data' || ctx.xStarted) {
          return 0;
        }

        // eslint-disable-next-line no-param-reassign
        ctx.xStarted = true;
        return ctx.index * delayBetweenPoints;
      },
    },
    y: {
      type: 'number',
      easing: 'linear',
      duration: delayBetweenPoints,
      from: previousY,
      delay(ctx) {
        if (ctx.type !== 'data' || ctx.yStarted) {
          return 0;
        }

        // eslint-disable-next-line no-param-reassign
        ctx.yStarted = true;
        return ctx.index * delayBetweenPoints;
      },
    },
  };
};
const getOptions = (datasetLength: number) => {
  const interaction = {
    intersect: false,
  };
  const plugins = {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    tooltip: {
      filter: () => false,
    },
  };
  const elements = {
    point: {
      pointStyle: false,
    },
  };
  const layout = {
    autoPadding: false,
    padding: 0,
  };
  const scales = {
    y: {
      display: false,
    },
    x: {
      display: false,
    },
  };
  const animations = getAnimation(datasetLength);

  return {
    animations,
    elements,
    layout,
    interaction,
    maintainAspectRatio: false,
    plugins,
    responsive: true,
    scales,
  };
};

const getData = (dataset: Array<string | number | undefined>, lineColor: string, fillColor: string | undefined) => {
  const datasetsOptions: Record<string, unknown> = {
    data: dataset,
    borderColor: lineColor,
    borderWidth: 1.5,
    fill: Boolean(fillColor),
    tension: 0.3,
  };

  if (fillColor) {
    datasetsOptions.backgroundColor = fillColor;
  }

  return {
    labels: [...Array(dataset.length).keys()],
    datasets: [datasetsOptions],
  };
};

const initialDataset = getDatasetData();

const data = ref(getData(initialDataset, props.lineColor, props.fillColor));
const options = ref(getOptions(initialDataset.length));

watch([() => props.chartData, () => props.lineColor, () => props.fillColor], () => {
  const dataset = getDatasetData();

  data.value = getData(dataset, props.lineColor, props.fillColor);
  options.value = getOptions(dataset.length);
});

return (_ctx: any,_cache: any) => {
  const _component_ot_chart_line = _resolveComponent("ot-chart-line")!

  return (_openBlock(), _createElementBlock("div", {
    class: "miniature-line-chart",
    style: _normalizeStyle(__props.chartStyle)
  }, [
    (buildChart.value)
      ? (_openBlock(), _createBlock(_component_ot_chart_line, {
          key: 0,
          class: "miniature-line-chart__graph",
          data: data.value,
          options: options.value
        }, null, 8, ["data", "options"]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})